import styled from 'styled-components'

import { tabDesktopBreakpoint } from '../constants'

export const BorderLevelOne = styled.div`
    display: none;
    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        background: #f6d47a;
        width: 98.46%;
        height: 97.12%;
        position: absolute;
        top: 1.28%;
        left: 0.76%;
        z-index: 2;
        display: block;
    }
`

export const BorderLevelTwo = styled.div`
    display: none;
    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        background: #ec744c;
        width: 98.46%;
        height: 97.12%;
        position: absolute;
        top: 2.56%;
        left: 1.53%;
        z-index: 1;
        display: block;
    }
`
